module.exports = "<div class=\"qr-bg\"></div>\n<h1 *ngIf=\"!error\" style=\"text-align: center;\">\n  Зачекайте...\n</h1>\n<h1 *ngIf=\"error\">\n  Помилка {{ errorCode }} <br>\n  {{ errorMessage }}\n</h1>\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/qr/qr.component.html
// module id = ../../../../../src/app/qr/qr.component.html
// module chunks = 0